import utils from '@/js/utils';
import MENU_AUDIENCIAS from '@/configs/menus/audiences.menu';
import { ROLES_LIST } from '@/js/constants';
export default [{
  path: '/audiences/list',
  name: 'link_list_audiences',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/audiences/AudiencesListPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('link_list_audiences', MENU_AUDIENCIAS)
  }
}, {
  path: '/audiences/detail',
  name: 'audience_detail',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/audiences/AudienceDetailPage.vue');
  },
  meta: {
    authentified: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }
}, {
  path: '/audiences/billing/:custom_audience_id',
  name: 'audience_billing',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/audiences/BillingPage.vue');
  },
  meta: {
    corporate: true,
    authentified: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }
}, {
  path: '/audiences/edit',
  name: 'audience_edit',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/audiences/CreateAudiencePage2.vue');
  },
  meta: {
    mode: 'edit',
    authentified: utils.getPermissiosInMenuDict('new_audience', MENU_AUDIENCIAS) //[ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN]
  }
}, {
  path: '/audiences/create',
  name: 'new_audience',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/audiences/CreateAudiencePage2.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('new_audience', MENU_AUDIENCIAS)
  }
}, {
  path: '/audiences/images/:key',
  name: 'audience_images',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/audiences/ImagePage.vue');
  },
  meta: {
    authentified: [ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  } //utils.getPermissiosInMenuDict('audience_images', MENU_AUDIENCIAS) }
}, {
  path: '/segments/list',
  name: 'segments',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/segments/SegmentsListPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('segments', MENU_AUDIENCIAS)
  }
}, {
  path: '/segments/cross_table',
  name: 'cross_table',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/segments/CruzarTablasPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('cross_table', MENU_AUDIENCIAS)
  }
}, {
  path: '/segments/view_cross_table',
  name: 'view_cross_table',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/segments/CruzarTablasPage.vue');
  },
  meta: {
    mode: "view",
    authentified: utils.getPermissiosInMenuDict('merge_segment', MENU_AUDIENCIAS) //[ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN]
  }
}, {
  path: '/segments/edit_cross_table',
  name: 'edit_cross_table',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/segments/CruzarTablasPage.vue');
  },
  meta: {
    mode: "edit",
    authentified: utils.getPermissiosInMenuDict('merge_segment', MENU_AUDIENCIAS) //[ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN]
  }
}, {
  path: '/segments/create',
  name: 'new_segment',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/segments/CreateSegmentPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('new_segment', MENU_AUDIENCIAS)
  }
}, {
  path: '/segments/view_segment',
  name: 'view_segment',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/segments/CreateSegmentPage.vue');
  },
  meta: {
    mode: "view",
    authentified: utils.getPermissiosInMenuDict('new_segment', MENU_AUDIENCIAS) //[ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN]
  }
}, {
  path: '/segments/edit_segment',
  name: 'edit_segment',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/segments/CreateSegmentPage.vue');
  },
  meta: {
    mode: "edit",
    authentified: utils.getPermissiosInMenuDict('new_segment', MENU_AUDIENCIAS) //[ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN]
  }
}, {
  path: '/digital_analytic/share',
  name: 'link_audiences_share',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/analytics/SharePage.vue');
  },
  meta: {
    mode: "edit",
    authentified: utils.getPermissiosInMenuDict('link_audiences_share', MENU_AUDIENCIAS) //[ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN]
  }
}, {
  path: '/digital_analytic/performance',
  name: 'link_audiences_performace',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/analytics/PerformancePage.vue');
  },
  meta: {
    mode: "edit",
    authentified: utils.getPermissiosInMenuDict('link_audiences_performace', MENU_AUDIENCIAS) //[ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN]
  }
}, {
  path: '/digital_analytic/monetization',
  name: 'link_audiences_monetization',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/analytics/MonetizationPage.vue');
  },
  meta: {
    mode: "edit",
    authentified: utils.getPermissiosInMenuDict('link_audiences_monetization', MENU_AUDIENCIAS) //[ROLES_LIST.AUDIENCE_ADMIN],
  }
}, {
  path: '/digital_analytic/omnichannel',
  name: 'link_audiences_omnichannel',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/analytics/OmnicanalPage.vue');
  },
  meta: {
    mode: "edit",
    authentified: utils.getPermissiosInMenuDict('link_audiences_omnichannel', MENU_AUDIENCIAS) //[ROLES_LIST.AUDIENCE_ADMIN],
  }
}, {
  path: '/segments/merge_segment',
  name: 'merge_segment',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/segments/MergeSegmentPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('merge_segment', MENU_AUDIENCIAS)
  }
}, {
  path: '/segments/view_merge_segment',
  name: 'view_merge_segment',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/segments/MergeSegmentPage.vue');
  },
  meta: {
    mode: "view",
    authentified: utils.getPermissiosInMenuDict('new_segment', MENU_AUDIENCIAS) //[ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN]
  }
}, {
  path: '/segments/edit_merge_segment',
  name: 'edit_merge_segment',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/segments/MergeSegmentPage.vue');
  },
  meta: {
    mode: "edit",
    authentified: utils.getPermissiosInMenuDict('new_segment', MENU_AUDIENCIAS) //[ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN]
  }
}, {
  path: '/configuration/exception',
  name: 'exception',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/configuration/ExceptionPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('exception', MENU_AUDIENCIAS) // [ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST]
  }
}, {
  path: '/configuration/flags',
  name: 'config_flags',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/configuration/FlagsPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('config_flags', MENU_AUDIENCIAS) // [ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST]
  }
}, {
  path: '/coupons/list',
  name: 'coupons_list',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/coupons/CouponsListPage.vue');
  },
  meta: {
    check_flag: 'audience/has_talonone_coupons',
    authentified: utils.getPermissiosInMenuDict('coupons_list', MENU_AUDIENCIAS) // [ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST]
  }
}, {
  path: '/coupons/create',
  name: 'coupons_create',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/coupons/CouponsCreatePage.vue');
  },
  meta: {
    check_flag: 'audience/has_talonone_coupons',
    authentified: utils.getPermissiosInMenuDict('coupons_create', MENU_AUDIENCIAS) // [ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST]
  }
}, {
  path: '/coupons/edit',
  name: 'coupons_edit',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/coupons/CouponsCreatePage.vue');
  },
  meta: {
    mode: "edit",
    check_flag: 'audience/has_talonone_coupons',
    authentified: utils.getPermissiosInMenuDict('coupons_create', MENU_AUDIENCIAS) // [ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST]
  }
}, {
  path: '/coupons/view',
  name: 'coupons_detail',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/coupons/CouponsDetailPage.vue');
  },
  meta: {
    mode: "view",
    check_flag: 'audience/has_talonone_coupons',
    authentified: utils.getPermissiosInMenuDict('coupons_create', MENU_AUDIENCIAS) // [ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.AUDIENCE_USER, ROLES_LIST.AUDIENCE_ANALYST]
  }
}, {
  path: '/campaigns/sandbox',
  name: 'campaigns_sandbox',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/campaigns/sandboxCampaignPage/SandboxCampaignPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('campaigns_sandbox', MENU_AUDIENCIAS)
  }
}, {
  path: '/campaigns/list',
  name: 'campaigns_list',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/campaigns/listCampaignPage/ListCampaignPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('campaigns', MENU_AUDIENCIAS)
  }
}, {
  path: '/campaigns/list/rules/:id_campaign?',
  name: 'campaigns_rules',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/campaigns/rulesCampaignPage/RulesCampaignPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('campaigns', MENU_AUDIENCIAS)
  }
}, {
  path: '/campaigns/list/campaign_history/:id_campaign?',
  name: 'campaigns_history',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/campaigns/listCampaignHistoryPage/ListCampaignHistoryPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('history', MENU_AUDIENCIAS)
  }
}, {
  path: '/campaigns/history',
  name: 'campaigns_history',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/campaigns/listCampaignHistoryPage/ListCampaignHistoryPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('history', MENU_AUDIENCIAS)
  }
}, {
  path: '/campaigns/variable',
  name: 'variable',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/campaigns/listVariablePage/ListVariablePage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('variable', MENU_AUDIENCIAS)
  }
}, {
  path: '/campaigns/variable_group',
  name: 'variable',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/campaigns/listVariablePage/ListVariablePage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('variable_group', MENU_AUDIENCIAS)
  }
}, {
  path: '/campaigns/report',
  name: 'campaigns_report',
  component: function component() {
    return import(/* webpackChunkName: "apps-auds" */'@/apps/audiences/modules/campaigns/listReport/ListReportPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('variable_group', MENU_AUDIENCIAS)
  }
}];